/* eslint-disable @typescript-eslint/no-explicit-any */
import { LanguageKey } from "@/types/generated/LanguageKey";
import { translate } from "@/hooks/useLanguage";
import { getConfigColumnStyle, headerProps } from "../../utils/tableUtils";
import { SortIcon } from "../shared";

interface DynamicTableHeaderProps {
  headerGroups: any[];
  toggleSortBy: (columnKey: string, desc: boolean) => void;
  isGroupedMode: boolean;
  onRenderConfig?: (original: any) => React.ReactNode;
}

export const DynamicTableHeader = ({
  headerGroups,
  toggleSortBy,
  isGroupedMode,
  onRenderConfig,
}: DynamicTableHeaderProps) => {
  return (
    <>
      {headerGroups.map((headerGroup: any, idx: any) => {
        const { key: groupKey, ...groupProps } =
          headerGroup.getHeaderGroupProps();
        return (
          <div key={groupKey ?? idx} {...groupProps} className="tr mh-30">
            {!isGroupedMode && onRenderConfig && (
              <div
                className="th align-items-center"
                style={getConfigColumnStyle()}
              />
            )}

            {headerGroup.headers.map((column: any, index: number) => {
              const { key: headerKey, ...headerPropsRest } =
                column.getHeaderProps(headerProps);
              return (
                <div
                  key={headerKey ?? index}
                  {...headerPropsRest}
                  className="th align-items-center justify-content-between"
                >
                  <div
                    className="d-flex align-items-center"
                    style={{ width: "calc(100% - 20px)" }}
                  >
                    <div
                      {...column.getSortByToggleProps({
                        title: column.description,
                      })}
                      onClick={() => {}}
                    >
                      {column.isGrouped && (
                        <span style={{ fontWeight: "normal" }}>
                          {translate(LanguageKey.group_by_key)}:{" "}
                        </span>
                      )}
                      {column.render("Header")}
                    </div>

                    <SortIcon
                      column={column}
                      toggleSortBy={toggleSortBy}
                      showHoverState={false}
                    />
                  </div>

                  <div
                    {...column.getResizerProps()}
                    className={`resizer ${column.isResizing ? "isResizing" : ""}`}
                  />
                </div>
              );
            })}
          </div>
        );
      })}
    </>
  );
};
